/**
 * Environment Configuration
 */

const getApiBaseUrl = (): string => {
  // Check if VITE_API_URL is explicitly set
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  
  // In production mode, use production API
  if (import.meta.env.PROD) {
    return 'https://api.serviceflow-pro.com/api'
  }
  
  // In development, use local API
  return 'http://localhost:3001/api'
}

export const env = {
  apiBaseUrl: getApiBaseUrl(),
  environment: import.meta.env.MODE || 'development',
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',
}


